import {OPEN_MODAL, CLOSE_MODAL} from '../constants/modal';

export const openModal = (modalType, data = null) => ({
    type: OPEN_MODAL,
    modalType: modalType,
    payload: data
});

export const closeModal = () => ({type: CLOSE_MODAL});
